<template>
  <div
    class="statistics-card font-weight-light"
    :style="`
      background-color: ${background_color};
      color: ${background_color?'black':''};
      border-color: ${background_color}
      `"
    >
    {{value}}
  </div>
</template>
<script>
export default {
  props: ['value', 'background_color'],
  data: () => ({
  }),
}
</script>
<style>
  .statistics-card {
    width: 100%;
    height: 26px;
    background-color: var(--v-color-4-base);
    border-style: solid;
    border-color: var(--header_border_color);
    border-width: 1px 1px 1px 0px;
    text-align: center;
    user-select: none;
  }
</style>
